import React, {useEffect} from "react";
import "./comment.scss";
import { COMMENTS_INPUT_MAX_LENGTH } from "utils/constants";
import { CommentInputProps } from "types/comments";
import { TextArea } from "components/common/TextArea.component";
import { FormField } from "components/common/FormField.component";

const Comment =  React.forwardRef<HTMLTextAreaElement, CommentInputProps>((props: CommentInputProps, ref) => {

    const [value, setValue] = React.useState(props.value);
    const inputLimit = props.inputLimit != null ? props.inputLimit : COMMENTS_INPUT_MAX_LENGTH;

    useEffect(() => {
        if(value !== props.value)
            changeValue(props.value);
    },[props.value]);

    const onChange = function(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const value = event.target.value;
        if (inputLimit <= 0 || value.length <= inputLimit) {
            changeValue(value);
        }
    };

    const changeValue = function(newValue: string) {
        setValue(newValue);
        props.propagateValue(newValue);
    }

    const valueLength = value ? value.length : 0;
    const charsLeftText = inputLimit > 0
        ? props.translate("input.comment.charsLeft", (inputLimit - valueLength))
        : undefined;

    return (
        <FormField
            id={props.id || "comment_textarea"}
            label={props.label}
            labelState={props.labelState}
            infoLabel={charsLeftText}
        >
            <TextArea
                id={props.id || "comment_textarea"}
                ref={ref}
                tabIndex={props.tabIndex}
                placeholder={props.inputHint}
                value={value || ''}
                onChange={onChange}
            />
        </FormField>
    );
});

export default Comment;